import styled, { css } from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const RectangularShapedButton = styled.button<{ $negative: boolean }>(
    ({ $negative }) => css`
        border-radius: ${getPurpurBorder('radiusMd')};
        border: ${getPurpurBorder('widthXs')} solid
            ${$negative ? getPurpurColor('borderStrongNegative') : getPurpurColor('borderWeak')};
        background: ${
            $negative ? getPurpurColor('backgroundInteractiveInactiveNegative') : getPurpurColor('backgroundSecondary')
        };
        padding: ${getPurpurSpacing('200')};
        display: inline-flex;
        align-items: center;
        gap: ${getPurpurSpacing('200')};

        &:hover {
            background: ${
                $negative
                    ? getPurpurColor('backgroundInteractiveTransparentHoverNegative')
                    : getPurpurColor('backgroundInteractiveTransparentHover')
            };
            cursor: pointer;
        }
        &:active {
            background: ${
                $negative
                    ? getPurpurColor('backgroundInteractiveTransparentActiveNegative')
                    : getPurpurColor('backgroundInteractiveTransparentActive')
            };
        }
        &:disabled {
            background: ${
                $negative
                    ? getPurpurColor('backgroundInteractiveDisabledNegative')
                    : getPurpurColor('backgroundInteractiveDisabled')
            };
            border-color: ${$negative ? getPurpurColor('borderStrongNegative') : getPurpurColor('borderWeak')};
            cursor: not-allowed;
        }
        ${purpurFocus()}
    `,
);

export const ButtonText = styled.span`
    margin-right: auto;
`;
